__turbopack_context__.v({
  "EditIcon": "fan-name-module__t5RAka__EditIcon",
  "FanName": "fan-name-module__t5RAka__FanName",
  "Name": "fan-name-module__t5RAka__Name",
  "Username": "fan-name-module__t5RAka__Username",
  "VerifiedIcon": "fan-name-module__t5RAka__VerifiedIcon",
  "underline": "fan-name-module__t5RAka__underline",
});
